module.exports = __webpack_public_path__ + "assets/e0bb77a5156207e48d268bd4879edb2b.mp3";